// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Col} from '../col/Col'
import {Container} from '../container/Container'
import {Row} from '../row/Row'
import {ContentArea} from "../content_area/ContentArea";

@Component({
    name: 'FixedFooter',
    components: {
        Col,
        Container,
        Row,
        ContentArea,
    },
    mixins: [
        template,
    ]
})
export class FixedFooter extends Vue {

    public prevHeight!: number

    public heightCheckTimeout: any = null

    public created () {

    }

    public mounted() {

        const fixedFooterHeight = this.$el.clientHeight

        document.body.style.paddingBottom = fixedFooterHeight + 'px'
        this.prevHeight = fixedFooterHeight

        const self = this

        this.heightCheckTimeout = setInterval(() => {

            const currentHeight = this.$el.clientHeight
            
            if(currentHeight != self.prevHeight) {
                document.body.style.paddingBottom = currentHeight + 'px'
            }
        }, 800)
    }

    public destroyed() {
        clearInterval(this.heightCheckTimeout)
        document.body.style.paddingBottom = ''
    }
}